import { render, staticRenderFns } from "./SourceSearch.vue?vue&type=template&id=9b47e802&scoped=true&"
import script from "./SourceSearch.vue?vue&type=script&lang=ts&"
export * from "./SourceSearch.vue?vue&type=script&lang=ts&"
import style0 from "./SourceSearch.vue?vue&type=style&index=0&id=9b47e802&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b47e802",
  null
  
)

export default component.exports